import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RestaurantFine"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 8.265V1.5H10.5V8.265C10.4958 10.4532 8.90938 12.3173 6.75 12.6713V22.5H5.25V12.6637C3.09729 12.3034 1.51523 10.4476 1.5 8.265V1.5H3V8.265C3.01854 9.92101 4.37395 11.2496 6.03 11.235C7.6696 11.2333 8.99835 9.9046 9 8.265ZM6.75 1.5H5.25V8.985H6.75V1.5ZM22.5 2.25V8.25C22.4965 10.4437 20.9128 12.3157 18.75 12.6825V21H21.75V22.5H14.25V21H17.25V12.6825C15.0872 12.3157 13.5035 10.4437 13.5 8.25V2.25C13.5 1.83579 13.8358 1.5 14.25 1.5H21.75C22.1642 1.5 22.5 1.83579 22.5 2.25ZM15 8.25V3H21V8.25C21 9.90685 19.6569 11.25 18 11.25C16.3431 11.25 15 9.90685 15 8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RestaurantFine.vue"]]);
